import { API_BASE_URL, ProductDocument } from '../services/api';

export const flattenProductDocuments = (documents: ProductDocument[] = []): ProductDocument[] =>
  documents.flatMap((document) => [document, ...flattenProductDocuments(document.childDocuments || [])]);

export const getProductDocumentTypeLabel = (type: string) => {
  switch (type) {
    case 'COA':
      return 'Certificate of Analysis';
    case 'MSDS':
      return 'Material Safety Data Sheet';
    default:
      return type.replace(/_/g, ' ');
  }
};

export const getProductDocumentTypeVariant = (type: string): 'success' | 'warning' | 'neutral' => {
  switch (type) {
    case 'COA':
      return 'success';
    case 'MSDS':
      return 'warning';
    default:
      return 'neutral';
  }
};

export const isPdfProductDocument = (document: ProductDocument) => {
  if (document.mimeType?.toLowerCase() === 'application/pdf') {
    return true;
  }

  return [document.originalName, document.fileName, document.fileUrl].some((value) =>
    value?.toLowerCase().endsWith('.pdf'),
  );
};

export const getProductDocumentUrl = (document: ProductDocument) =>
  `${API_BASE_URL}/${document.fileUrl.replace(/\\/g, '/')}`;

export const getProductDocumentParentOptions = (
  documents: ProductDocument[],
  depth = 0,
): Array<{ id: number; label: string }> =>
  documents.flatMap((document) => [
    {
      id: document.id,
      label: `${depth > 0 ? `${'  '.repeat(depth)}- ` : ''}${document.fileName || document.originalName || 'Document'}`,
    },
    ...getProductDocumentParentOptions(document.childDocuments || [], depth + 1),
  ]);
